//todo: write this lib, including an export for auth user profile,
// and then a user (as we fetch when viewing our users)

import APIBase from "./apiBase";
import { Inbox } from "./inboxLib";
import { Experience } from "./experiencesLib";

export type AuthedUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  profilePicture: string;
  challengeEnabled: boolean;
  challengeMessage: string;
  bypassEnabled: boolean;
  bypassMessage: string;
  isSuperAdmin: boolean;
  minimumDonation: number;
  defaultDonation: number;
  createdAt: Date;
  inboxes: Inbox[];
  experiences?: Experience[];
};

export const me = async (): Promise<User | null> => {
  if (APIBase.hasSessionToken()) {
    const { data } = await APIBase.get<User>(`/users/me`);
    return data;
  } else return null;
};
export const get = async (id: string): Promise<User> => {
  const { data } = await APIBase.get<User>(`/users/${id}`);
  return data;
};

//fetches a list of users from /users
export const list = async (): Promise<User[]> => {
  const { data } = await APIBase.get<User[]>(`/users`);
  console.log(`Loaded ${data.length} users`);
  return data.map((el: User) => {
    el.createdAt = new Date(el.createdAt);
    return el;
  });
};
